module.exports = __webpack_public_path__ + "static/media/ml.f462811f.svg";